/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Week_Title_LeadInputs */

const en_portal_week_title_lead = /** @type {(inputs: Portal_Week_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A whole week of training`)
};

const pl_portal_week_title_lead = /** @type {(inputs: Portal_Week_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cały tydzień treningów`)
};

/**
* | output |
* | --- |
* | "A whole week of training" |
*
* @param {Portal_Week_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_week_title_lead = /** @type {((inputs?: Portal_Week_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Week_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_week_title_lead(inputs)
	return en_portal_week_title_lead(inputs)
});